import { GEO_SIM_MINT_PATH } from "./constants";

export type MintGeoSimResult =
  | { ok: true; token: string; exp?: number; ttlSeconds?: number }
  | { ok: false; error: string; code?: string; status: number };

/**
 * Mint HMAC geo-sim token from origin (Clerk Authorization headers required).
 * Never invent or hardcode gst.
 */
export async function mintGeoSimTokenFromApi(
  getAuthHeaders: () => Promise<Record<string, string>> | Record<string, string>,
  opts?: { ttlSeconds?: number; clear?: boolean },
): Promise<MintGeoSimResult> {
  const headers = await Promise.resolve(getAuthHeaders());
  const url =
    opts?.clear === true
      ? `${GEO_SIM_MINT_PATH}?clear=1`
      : GEO_SIM_MINT_PATH;

  let res: Response;
  try {
    res = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...headers,
      },
      body: JSON.stringify(
        opts?.clear
          ? { clear: true }
          : opts?.ttlSeconds
            ? { ttlSeconds: opts.ttlSeconds }
            : {},
      ),
      credentials: "include",
    });
  } catch (e) {
    return {
      ok: false,
      error: e instanceof Error ? e.message : "Error de red",
      status: 0,
    };
  }

  const data = (await res.json().catch(() => ({}))) as {
    ok?: boolean;
    token?: string;
    error?: string;
    code?: string;
    exp?: number;
    ttlSeconds?: number;
    cleared?: boolean;
  };

  if (opts?.clear) {
    if (res.ok && data.ok) return { ok: true, token: "" };
    return {
      ok: false,
      error: data.error || `Clear failed (${res.status})`,
      status: res.status,
    };
  }

  if (!res.ok || !data.ok || !data.token) {
    return {
      ok: false,
      error: data.error || `Mint failed (${res.status})`,
      code: data.code,
      status: res.status,
    };
  }

  return {
    ok: true,
    token: data.token,
    exp: data.exp,
    ttlSeconds: data.ttlSeconds,
  };
}
